import React, { useEffect, useMemo, useState } from "react";
import { activeDialogState } from "../../redux/slices/dialogsSlice";
import { useSelector } from "react-redux";
import { ReduxUpdater } from "../../redux/ReduxUpdater";
import { JsonUploadForm } from "./components/json-upload-form";
import { GlobalVariables } from "../../GlobalVariables";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ButtonGroup } from "../components/ui/button-group";
import { Button } from "../components/ui/button";
import { lastAuthenticatedUserState } from "../../redux/slices/tsSlice";
import { ApiCalls, emptyResponseData, ICrewData, ICrewResponseData } from "../../ApiCalls";
import { selectedYachtState } from "../../redux/slices/yachtSlice";
import { GlobalConstants } from "../../GlobalConstants";

type Security = {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
};

type Notifications = {
    product: boolean;
    security: boolean;
    newsletters: boolean;
    sms: boolean;
};

type Preferences = {
    language: string;
    timezone: string;
    theme: "system" | "light" | "dark";
};

// ---- Component ----

const leftNav = [
    {
        id: "profile", label: "Profile", icon: (
            <svg className="shrink-0 size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21a8 8 0 0 0-16 0" /><circle cx="12" cy="7" r="4" /></svg>
        )
    },
    // {
    //     id: "security", label: "Security", icon: (
    //         <svg className="shrink-0 size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" /></svg>
    //     )
    // },
    // {
    //     id: "notifications", label: "Notifications", icon: (
    //         <svg className="shrink-0 size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.7 1.7 0 0 0 3.4 0" /></svg>
    //     )
    // },
    // {
    //     id: "preferences", label: "Preferences", icon: (
    //         <svg className="shrink-0 size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v3" /><path d="M12 18v3" /><path d="M3 12h3" /><path d="M18 12h3" /><circle cx="12" cy="12" r="3" /></svg>
    //     )
    // },
    // {
    //     id: "upload", label: "Upload Data", icon: (
    //         <svg className="shrink-0 size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v12"/><path d="m17 8-5-5-5 5"/><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/></svg>
    //     )
    // },
];

if (ReduxUpdater.adminAuthenticatedUser?.email === 'david.lednik@gmail.com') {
    leftNav.push({
        id: "admin", label: "Admin", icon: (
            <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#1f1f1f"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><g><path d="M4,18v-0.65c0-0.34,0.16-0.66,0.41-0.81C6.1,15.53,8.03,15,10,15c0.03,0,0.05,0,0.08,0.01c0.1-0.7,0.3-1.37,0.59-1.98 C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26c-0.42-0.6-0.75-1.28-0.97-2H4z"/><path d="M10,12c2.21,0,4-1.79,4-4s-1.79-4-4-4C7.79,4,6,5.79,6,8S7.79,12,10,12z M10,6c1.1,0,2,0.9,2,2s-0.9,2-2,2 c-1.1,0-2-0.9-2-2S8.9,6,10,6z"/><path d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z"/></g></g></svg>
        )
    });
}

const SettingsDialog = () => {
    const authenticatedUserTS =  useSelector(lastAuthenticatedUserState);
    const currentActiveDialogState = useSelector(activeDialogState);
    const currentSelectedYachtState = useSelector(selectedYachtState);
    const navigate = useNavigate();
    
    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState<string>("profile");

    const [crewData, setCrewData] = React.useState<ICrewResponseData>(emptyResponseData);
        
    React.useEffect(() => {
        if (!currentSelectedYachtState) {
            return;
        }
        ApiCalls.crew(currentSelectedYachtState.id).then(d => setCrewData(d)).catch(err => console.error(err));
    }, [currentSelectedYachtState]);

    // const [profile, setProfile] = useState<Profile>({
    //     fullName: "",
    //     email: "",
    //     username: "",
    //     bio: "",
    //     avatar: null,
    // });
    const [security, setSecurity] = useState<Security>({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [notif, setNotif] = useState<Notifications>({
        product: true,
        security: true,
        newsletters: false,
        sms: false,
    });
    const [pref, setPref] = useState<Preferences>({
        language: "en",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta",
        theme: "system",
    });

    const [errors, setErrors] = useState<Record<string, string>>({});
    const hasErrors = useMemo(() => Object.keys(errors).length > 0, [errors]);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                ReduxUpdater.currentDialog = null;
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    useEffect(() => {
        setOpen(currentActiveDialogState === 'userSettings');
    }, [currentActiveDialogState]);

    function validate(): boolean {
        const next: Record<string, string> = {};

        if (!ReduxUpdater.authenticatedUser?.first_name.trim()) next.fullName = "Full name is required";
        if (!ReduxUpdater.authenticatedUser?.last_name.trim()) next.username = "Username is required";
        if (!ReduxUpdater.authenticatedUser?.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) next.email = "Valid email required";

        if (security.newPassword || security.confirmPassword) {
            if (security.newPassword.length < 8) next.newPassword = "Min 8 characters";
            if (security.newPassword !== security.confirmPassword) next.confirmPassword = "Passwords don't match";
        }

        setErrors(next);
        return Object.keys(next).length === 0;
    }

    const handleClose = () => {
        ReduxUpdater.currentDialog = null;
    };

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        if (!validate()) return;

        // Simulate async save
        await new Promise((r) => setTimeout(r, 500));
        alert("Settings saved! (Replace with API call)");
        handleClose();
    }

    function handleUserRole(e: React.FormEvent, role: string) {
        e.preventDefault();
        const user = ReduxUpdater.adminAuthenticatedUser;
        if (!user) {
            return;
        }
        if (user.impersonate) {
            user.impersonate.user_role = role;
        } else {
            user.user_role = role;
        }
        ReduxUpdater.authenticatedUser = {...user};
    }

    function handleImpersonateUser(e: React.FormEvent, crew: ICrewData | null) {
        e.preventDefault();
        const user = ReduxUpdater.adminAuthenticatedUser;
        if (!user) {
            return;
        }
        ReduxUpdater.authenticatedUser = {
            ...user,
            impersonate: crew,
        };
    }

    // ------ UI helpers ------
    const NavButton: React.FC<{ id: string; label: string; icon: React.ReactNode }> = ({ id, label, icon }) => (
        <button
            type="button"
            onClick={() => setTab(id)}
            className={[
                "group w-full flex items-center gap-x-3 px-3 py-2 rounded-lg text-sm",
                tab === id
                    ? "bg-amber-50 text-amber-700 ring-1 ring-amber-200"
                    : "text-gray-600 hover:bg-gray-50",
            ].join(" ")}
            aria-current={tab === id}
        >
            <span className={tab === id ? "text-amber-600" : "text-gray-500"}>{icon}</span>
            <span className="font-medium">{label}</span>
        </button>
    );

    const tabAdmin = React.useMemo(() => {
        if (tab !== "admin") {
            return null;
        }
        
        return (
            <div className="space-y-6">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Emulate user Role:</label>
                    <ButtonGroup aria-label="Basic button group">
                        <Button
                            className={`rounded-xl ${ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.ROOT ? 'bg-blue-400' : ''}`}
                            onClick={(e) => handleUserRole(e, GlobalConstants.UserRole.ROOT)}
                        >
                            {GlobalConstants.UserRole.ROOT}
                        </Button>
                        <Button
                            className={`rounded-xl ${ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.ADMIN ? 'bg-blue-400' : ''}`}
                            onClick={(e) => handleUserRole(e, GlobalConstants.UserRole.ADMIN)}
                        >
                            {GlobalConstants.UserRole.ADMIN}
                        </Button>
                        <Button
                            className={`rounded-xl ${ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.STANDARD ? 'bg-blue-400' : ''}`}
                            onClick={(e) => handleUserRole(e, GlobalConstants.UserRole.STANDARD)}
                        >
                            {'Standard' /*GlobalConstants.UserRole.STANDARD*/}
                        </Button>
                        <Button
                            className={`rounded-xl ${ReduxUpdater.authenticatedUser?.user_role === GlobalConstants.UserRole.BASIC ? 'bg-blue-400' : ''}`}
                            onClick={(e) => handleUserRole(e, GlobalConstants.UserRole.BASIC)}
                        >
                            {GlobalConstants.UserRole.BASIC}
                        </Button>
                    </ButtonGroup>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700">Impersonate:</label>
                    <ButtonGroup aria-label="Basic button group">
                        <Button
                            className={`rounded-xl ${ReduxUpdater.adminAuthenticatedUser?.impersonate === null || ReduxUpdater.adminAuthenticatedUser?.impersonate === undefined ? 'bg-blue-400' : ''}`}
                            onClick={(e) => handleImpersonateUser(e, null)}
                        >
                            None
                        </Button>
                        {crewData
                            .items
                            // .filter(o => o.id !== ReduxUpdater.adminAuthenticatedUser?.id)
                            .map(c =>
                            <Button
                                className={`rounded-xl ${ReduxUpdater.adminAuthenticatedUser?.impersonate?.id === c.id ? 'bg-blue-400' : ''}`}
                                onClick={(e) => handleImpersonateUser(e, c)}
                            >
                                {c.first_name} {c.last_name}
                            </Button>
                        )}
                    </ButtonGroup>
                </div>
            </div>
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticatedUserTS, tab]);

    return (
        <div>
            {/* Overlay */}
            {open && (
                <div className="hs-overlay fixed inset-0 z-[60] overflow-y-auto bg-gray-900/50 p-4">
                    <div className="w-[1262px] max-w-[100vw] h-[-webkit-fill-available] flex justify-center items-center overflow-hidden">
                        <div className="relative grid grid-cols-1 overflow-hidden rounded-2xl bg-white shadow-xl ring-1 ring-gray-200 md:grid-cols-12">
                            {/* Close */}
                            <button
                                type="button"
                                onClick={handleClose}
                                className="absolute right-3 top-3 inline-flex size-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-amber-500"
                                aria-label="Close"
                            >
                                <svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6 6 18M6 6l12 12" /></svg>
                            </button>

                            {/* Left nav */}
                            <aside className="md:col-span-4 lg:col-span-3 border-b md:border-b-0 md:border-r border-gray-200 bg-gray-50/60">
                                <div className="p-4 sm:p-6">
                                    <h3 className="text-sm font-semibold text-gray-900">Settings</h3>
                                    <p className="mt-1 text-xs text-gray-500">Manage your account preferences</p>
                                    <div className="mt-4 space-y-1">
                                        {leftNav.map((n) => (
                                            <NavButton key={n.id} id={n.id} label={n.label} icon={n.icon} />
                                        ))}
                                    </div>
                                </div>
                            </aside>

                            {/* Right content */}
                            <section className="md:col-span-8 lg:col-span-9">
                                <form onSubmit={handleSubmit} className="p-4 sm:p-6">
                                    {/* Header */}
                                    <div className="mb-4 flex items-center justify-between">
                                        <div>
                                            <h3 className="text-base font-semibold text-gray-900 capitalize">{tab}</h3>
                                            {hasErrors && <p className="mt-1 text-xs text-red-600">Please fix the errors below.</p>}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <button
                                                type="button"
                                                onClick={handleClose}
                                                className="rounded-lg border border-gray-200 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="inline-flex items-center gap-x-2 rounded-lg bg-amber-600 px-3.5 py-2.5 text-sm font-semibold text-white hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500"
                                            >
                                                <svg className="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6 9 17l-5-5" /></svg>
                                                Save changes
                                            </button>
                                        </div>
                                    </div>

                                    {/* Tabs content */}
                                    {tab === "profile" && (
                                        <div className="space-y-6">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">First name</label>
                                                <input
                                                    className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${errors.firstName ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-amber-500"}`}
                                                    value={ReduxUpdater.authenticatedUser?.first_name}
                                                    // onChange={(e) => setProfile({ ...profile, fullName: e.target.value })}
                                                    placeholder="First Name"
                                                />
                                                {errors.firstName && <p className="mt-1 text-xs text-red-600">{errors.firstName}</p>}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Last name</label>
                                                <input
                                                    className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${errors.lastName ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-amber-500"}`}
                                                    value={ReduxUpdater.authenticatedUser?.last_name}
                                                    // onChange={(e) => setProfile({ ...profile, username: e.target.value })}
                                                    placeholder="Last Name"
                                                />
                                                {errors.lastName && <p className="mt-1 text-xs text-red-600">{errors.lastName}</p>}
                                            </div>

                                            <div className="grid gap-4 sm:grid-cols-2">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Email</label>
                                                    <input
                                                        type="email"
                                                        className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${errors.email ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-amber-500"}`}
                                                        value={ReduxUpdater.authenticatedUser?.email}
                                                        // onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                                                        placeholder="you@example.com"
                                                    />
                                                    {errors.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
                                                </div>
                                            </div>

                                            {/* <div>
                                                <label className="block text-sm font-medium text-gray-700">Bio</label>
                                                <textarea
                                                    rows={3}
                                                    className="mt-1 block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
                                                    value={profile.bio}
                                                    onChange={(e) => setProfile({ ...profile, bio: e.target.value })}
                                                    placeholder="Short introduction..."
                                                />
                                            </div> */}

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Avatar</label>
                                                <div className="mt-1 flex items-center gap-4">
                                                    <div className="size-14 overflow-hidden rounded-full ring-1 ring-gray-200">
                                                        <img
                                                            className="shrink-0 size-12 rounded-full"
                                                            src={ReduxUpdater.authenticatedUser?.profile_image_bytes}
                                                            alt={ReduxUpdater.authenticatedUser?.first_name + ' ' + ReduxUpdater.authenticatedUser?.last_name}
                                                        />
                                                    </div>
                                                    <label className="inline-flex cursor-pointer items-center gap-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                                                        <svg className="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 5v14M5 12h14" /></svg>
                                                            Upload
                                                        {/* <input
                                                            type="file"
                                                            accept="image/*"
                                                            className="hidden"
                                                            onChange={(e) => setProfile({ ...profile, avatar: e.target.files?.[0] || null })}
                                                        /> */}
                                                    </label>

                                                    <label className="inline-flex cursor-pointer items-center gap-x-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                                                        <button
                                                            onClick={() => {
                                                                GlobalVariables.handleLogout(
                                                                    () => {
                                                                        toast.success('Logged out');
                                                                        navigate(0);
                                                                    },
                                                                    () => {toast.error('Error logging out');},
                                                                )
                                                            }}
                                                        >Logout</button>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {tab === "security" && (
                                        <div className="space-y-6">
                                            <div className="grid gap-4 sm:grid-cols-2">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Current password</label>
                                                    <input
                                                        type="password"
                                                        className="mt-1 block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
                                                        value={security.currentPassword}
                                                        onChange={(e) => setSecurity({ ...security, currentPassword: e.target.value })}
                                                    />
                                                </div>
                                                <div></div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">New password</label>
                                                    <input
                                                        type="password"
                                                        className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${errors.newPassword ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-amber-500"}`}
                                                        value={security.newPassword}
                                                        onChange={(e) => setSecurity({ ...security, newPassword: e.target.value })}
                                                        placeholder="At least 8 characters"
                                                    />
                                                    {errors.newPassword && <p className="mt-1 text-xs text-red-600">{errors.newPassword}</p>}
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Confirm password</label>
                                                    <input
                                                        type="password"
                                                        className={`mt-1 block w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 ${errors.confirmPassword ? "border-red-300 focus:ring-red-500" : "border-gray-200 focus:ring-amber-500"}`}
                                                        value={security.confirmPassword}
                                                        onChange={(e) => setSecurity({ ...security, confirmPassword: e.target.value })}
                                                    />
                                                    {errors.confirmPassword && <p className="mt-1 text-xs text-red-600">{errors.confirmPassword}</p>}
                                                </div>
                                            </div>

                                            <div className="rounded-xl border border-amber-100 bg-amber-50 p-4 text-sm text-amber-900">
                                                Tip: Use a passphrase with 3–4 random words for better security.
                                            </div>
                                        </div>
                                    )}

                                    {tab === "notifications" && (
                                        <div className="space-y-4">
                                            {([
                                                { key: "product", label: "Product updates", desc: "Feature releases, tips, and tutorials" },
                                                { key: "security", label: "Security alerts", desc: "Unusual activity, password changes" },
                                                { key: "newsletters", label: "Newsletters", desc: "Monthly roundups and stories" },
                                                { key: "sms", label: "SMS alerts", desc: "Time-sensitive notices by text" }
                                            ] as const)
                                                .map(item => (
                                                    <label key={item.key} className="flex w-full items-start gap-3 rounded-lg border border-gray-200 p-3 hover:bg-gray-50">
                                                        <input
                                                            type="checkbox"
                                                            className="mt-1 size-4 rounded border-gray-300 text-amber-600 focus:ring-amber-500"
                                                            checked={notif[item.key]}
                                                            onChange={(e) => setNotif({ ...notif, [item.key]: e.target.checked })}
                                                        />
                                                        <span>
                                                            <span className="block text-sm font-medium text-gray-900">{item.label}</span>
                                                            <span className="block text-xs text-gray-500">{item.desc}</span>
                                                        </span>
                                                    </label>
                                                ))}
                                        </div>
                                    )}

                                    {tab === "preferences" && (
                                        <div className="space-y-6">
                                            <div className="grid gap-4 sm:grid-cols-2">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Language</label>
                                                    <select
                                                        className="mt-1 block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
                                                        value={pref.language}
                                                        onChange={(e) => setPref({ ...pref, language: e.target.value })}
                                                    >
                                                        <option value="en">English</option>
                                                        <option value="id">Bahasa Indonesia</option>
                                                        <option value="ms">Bahasa Melayu</option>
                                                        <option value="ja">日本語</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Time zone</label>
                                                    <input
                                                        className="mt-1 block w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500"
                                                        value={pref.timezone}
                                                        onChange={(e) => setPref({ ...pref, timezone: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <fieldset>
                                                <legend className="mb-2 block text-sm font-medium text-gray-700">Theme</legend>
                                                <div className="grid gap-3 sm:grid-cols-3">
                                                    {([{ val: "system", label: "System" }, { val: "light", label: "Light" }, { val: "dark", label: "Dark" }] as const)
                                                        .map(({ val, label }) => (
                                                            <label key={val} className={`flex items-center gap-3 rounded-lg border p-3 ${pref.theme === val ? "border-amber-300 bg-amber-50" : "border-gray-200 hover:bg-gray-50"}`}>
                                                                <input
                                                                    type="radio"
                                                                    name="theme"
                                                                    className="size-4 border-gray-300 text-amber-600 focus:ring-amber-500"
                                                                    checked={pref.theme === val}
                                                                    onChange={() => setPref({ ...pref, theme: val as Preferences["theme"] })}
                                                                />
                                                                <span className="text-sm text-gray-800">{label}</span>
                                                            </label>
                                                        ))}
                                                </div>
                                            </fieldset>
                                        </div>
                                    )}

                                    {tab === "upload" && (
                                        <JsonUploadForm />
                                    )}

                                    {tabAdmin}
                                </form>
                            </section>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SettingsDialog;
